import gql from "graphql-tag";

export const UPSERT_ROLE_MUTATION = gql`
  mutation UpsertRoleMutation(
    $name: String
    $create: RoleCreateInput!
    $update: RoleUpdateInput!
  ) {
    upsertRole(create: $create, update: $update, where: { name: $name }) {
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/UpsertRole/queries.ts